import { filter, Observable } from 'rxjs';
import { ConnectionState, ServerEventMessage } from '../../models';

export abstract class ServerEventsProviderService {
  abstract getServerEventsFeed(): Observable<ServerEventMessage>;
  abstract getConnectionState(): Observable<ConnectionState>;
  abstract getLogs(): Observable<any>;

  getServerEvent(messageType: string): Observable<ServerEventMessage> {
    return this.getServerEventsFeed().pipe(filter((serverEvent) => serverEvent.message_type === messageType));
  }
}
